import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { PaginaExternaComponent } from './pagina-externa/pagina-externa.component';
import { InicioComponent } from './pagina-externa/inicio/inicio.component';
import { HeaderComponent } from './pagina-externa/inicio/header/header.component';
import { FooterComponent } from './pagina-externa/inicio/footer/footer.component';
import { PaginaInicialComponent } from './pagina-externa/inicio/pagina-inicial/pagina-inicial.component';
import { FederalismoComponent } from './pagina-externa/micrositios/transiciones-y-transformaciones/federalismo/federalismo.component';
import { CompositoresComponent } from './pagina-externa/micrositios/miradas-desde-el-arte/compositores/compositores.component';
import { RetratoFotoComponent } from './pagina-externa/micrositios/miradas-desde-el-arte/retrato-foto/retrato-foto.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';

import { HttpClientModule } from "@angular/common/http";
import { CollapseModule } from 'angular-bootstrap-md';


//MODULOS
import { SidebarModule } from 'ng-sidebar';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LaEducacionComponent } from './pagina-externa/micrositios/educacion/la-educacion/la-educacion.component';
import { ComposicionesCantadasHimnosComponent } from './pagina-externa/micrositios/educacion/composiciones-cantadas-himnos/composiciones-cantadas-himnos.component';
import { GramaticasCatecismosComponent } from './pagina-externa/micrositios/educacion/gramaticas-catecismos/gramaticas-catecismos.component';
import { ArteDelPoetaComponent } from './pagina-externa/micrositios/creadores/arte-del-poeta/arte-del-poeta.component';
import { clorindaMattoTurnerComponent } from './pagina-externa/micrositios/creadores/clorinda-mato-turner/clorinda-mato-turner.component';
import { PensadoresSXIXComponent } from './pagina-externa/micrositios/creadores/pensadores-sxix/pensadores-sxix.component';
import { RetratosInmigracionComponent } from './pagina-externa/micrositios/micriositio11/retratos-inmigracion/retratos-inmigracion.component';
import { MalagaGrenetComponent } from './pagina-externa/micrositios/micriositio12/malaga-grenet/malaga-grenet.component';
import { FichaComponent } from './pagina-externa/ficha/ficha.component';
import { VisorComponent } from './pagina-externa/visor/visor.component';
import { MagdaPortalComponent } from './pagina-externa/micrositios/micriositio13/magda-portal/magda-portal.component';
import { JoseMariaArguedasComponent } from './pagina-externa/micrositios/micriositio14/jose-maria-arguedas/jose-maria-arguedas.component';
import { MiradasAlAntiguoPeruComponent } from './pagina-externa/micrositios/micriositio15/miradas-al-antiguo-peru/miradas-al-antiguo-peru.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { Generica1Component } from './pagina-externa/adicionalHome/generica1/generica1.component';
import { Generica2Component } from './pagina-externa/adicionalHome/generica2/generica2.component';
import { Generica3Component } from './pagina-externa/adicionalHome/generica3/generica3.component';
import { Generica4Component } from './pagina-externa/adicionalHome/generica4/generica4.component';
import { AlbumRepublicaPeruanaComponent } from './pagina-externa/micrositios/miradas-desde-el-arte/album-republica-peruana/album-republica-peruana.component';
import { PresentacionComponent } from './pagina-externa/adicionalHome/presentacion/presentacion.component';
import { DoraMayerComponent } from './pagina-externa/micrositios/micrositio16/dora-mayer/dora-mayer.component';
import { ManuelGonzalezPradaComponent } from './pagina-externa/micrositios/micrositio17/manuel-gonzalez-prada/manuel-gonzalez-prada.component';
import { NoticierosComponent } from './pagina-externa/micrositios/micrositio18/noticieros/noticieros.component';
import { RicardoPalmaComponent } from './pagina-externa/micrositios/micrositio19/ricardo-palma/ricardo-palma.component';
import { DerechosMujerComponent } from './pagina-externa/micrositios/micrositio20/derechos-mujer/derechos-mujer.component';
import { ConstruccionTradicionComponent } from './pagina-externa/micrositios/micrositio21/construccion-tradicion/construccion-tradicion.component';
import { ImprentaComponent } from './pagina-externa/micrositios/micrositio22/imprenta/imprenta.component';
import { JorgeBasadreComponent } from './pagina-externa/micrositios/micrositio23/jorge-basadre/jorge-basadre.component';
import { IncaGarcilazoComponent } from './pagina-externa/micrositios/micrositio24/inca-garcilazo/inca-garcilazo.component';
import { PrensaIndependenciaComponent } from './pagina-externa/micrositios/micrositio25/prensa-independencia/prensa-independencia.component';
import { MariaAlvaradoComponent } from './pagina-externa/micrositios/micrositio26/maria-alvarado/maria-alvarado.component';
import { AlbumAutografosComponent } from './pagina-externa/micrositios/micrositio27/album-autografos/album-autografos.component';
import { JustoSahuarauraComponent } from './pagina-externa/micrositios/micrositio28/justo-sahuaraura/justo-sahuaraura.component';
import { ExLibrisComponent } from './pagina-externa/micrositios/micrositio29/ex-libris/ex-libris.component';
import { RetratosFamiliaresComponent } from './pagina-externa/micrositios/micrositio30/retratos-familiares/retratos-familiares.component';
import { ModaSigloComponent } from './pagina-externa/micrositios/micrositio31/moda-siglo/moda-siglo.component';
import { MemoriaRecuperadaComponent } from './pagina-externa/micrositios/micrositio32/memoria-recuperada/memoria-recuperada.component';
import { RenacerCenizasComponent } from './pagina-externa/micrositios/micrositio33/renacer-cenizas/renacer-cenizas.component';
import { FernandoGarreaudComponent } from './pagina-externa/micrositios/micrositio34/fernando-garreaud/fernando-garreaud.component';
import { LenguasOriginariasComponent } from './pagina-externa/micrositios/micrositio35/lenguas-originarias/lenguas-originarias.component';
import { SesquicentenarioComponent } from './pagina-externa/micrositios/micrositio36/sesquicentenario/sesquicentenario.component';
import { BernardoAlzedoComponent } from './pagina-externa/micrositios/micrositio37/bernardo-alzedo/bernardo-alzedo.component';
import { CesarVallejoComponent } from './pagina-externa/micrositios/micrositio38/cesar-vallejo/cesar-vallejo.component';
import { MariaWiesseComponent } from './pagina-externa/micrositios/micrositio39/maria-wiesse/maria-wiesse.component';
import { AngelicaPalmaComponent } from './pagina-externa/micrositios/micrositio40/angelica-palma/angelica-palma.component';
import { NicomedesSantacruzComponent } from './pagina-externa/micrositios/micrositio41/nicomedes-santacruz/nicomedes-santacruz.component';
import { Noticieros2Component } from './pagina-externa/micrositios/micrositio42/noticieros2/noticieros2.component';


@NgModule({
  declarations: [
    AppComponent,
    PaginaExternaComponent,
    InicioComponent,
    HeaderComponent,
    FooterComponent,
    PaginaInicialComponent,
    FederalismoComponent,
    CompositoresComponent,
    RetratoFotoComponent,
    LaEducacionComponent,
    ComposicionesCantadasHimnosComponent,
    GramaticasCatecismosComponent,
    ArteDelPoetaComponent,
    clorindaMattoTurnerComponent,
    PensadoresSXIXComponent,
    RetratosInmigracionComponent,
    MalagaGrenetComponent,
    FichaComponent,
    VisorComponent,
    MagdaPortalComponent,
    JoseMariaArguedasComponent,
    MiradasAlAntiguoPeruComponent,
    Generica2Component,
    Generica3Component,
    Generica4Component,
    AlbumRepublicaPeruanaComponent,
    Generica1Component,
    PresentacionComponent,
    DoraMayerComponent,
    ManuelGonzalezPradaComponent,
    NoticierosComponent,
    RicardoPalmaComponent,
    DerechosMujerComponent,
    ConstruccionTradicionComponent,
    ImprentaComponent,
    JorgeBasadreComponent,
    IncaGarcilazoComponent,
    PrensaIndependenciaComponent,
    MariaAlvaradoComponent,
    AlbumAutografosComponent,
    JustoSahuarauraComponent,
    ExLibrisComponent,
    RetratosFamiliaresComponent,
    ModaSigloComponent,
    MemoriaRecuperadaComponent,
    RenacerCenizasComponent,
    FernandoGarreaudComponent,
    LenguasOriginariasComponent,
    SesquicentenarioComponent,
    BernardoAlzedoComponent,
    CesarVallejoComponent,
    MariaWiesseComponent,
    AngelicaPalmaComponent,
    NicomedesSantacruzComponent,
    Noticieros2Component,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    SidebarModule.forRoot(),
    AccordionModule.forRoot(),
    BrowserAnimationsModule,
    SlickCarouselModule,
    IvyCarouselModule,
    HttpClientModule,
    CollapseModule.forRoot(),
    NgxLoadingModule.forRoot({ animationType: ngxLoadingAnimationTypes.wanderingCubes, fullScreenBackdrop: true }),

  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
